import { COURSE_LIST_FAIL, COURSE_LIST_REQUEST, COURSE_LIST_SUCCESS } from "./course.constants";

export const courseListReducer = (state = { courses: [] }, action) => {
    switch (action.type) {
        case COURSE_LIST_REQUEST:
            return { ...state, loading: true };
        case COURSE_LIST_SUCCESS:
            return { loading: false, success: true, courses: action.payload };
        case COURSE_LIST_FAIL:
            return { loading: false, error: action.payload };
        // case USER_LIST_RESET:
        //     return { users: [] };
        default:
            return state;
    }
};